import { Link, useLocation } from "react-router-dom";
import { scrollToTop } from "../../utils/Constants";
import "../../styles/components/logo.scss";

export default function Logo({ className = "" }) {
    const { pathname } = useLocation();
    const onHelp = pathname.startsWith("/help");

    return (
        <Link
            to={onHelp ? "/help" : "/"}
            className={`logo${className ? ` ${className}` : ""}`}
            onClick={scrollToTop}
        >
            <span className="logo__icon" aria-hidden="true">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    stroke="none"
                >
                    <path d="M20.84 12c0 2.05 .985 3.225 -.04 5c-1.026 1.775 -2.537 1.51 -4.314 2.534c-1.776 1.026 -2.302 2.466 -4.353 2.466c-2.051 0 -2.576 -1.441 -4.353 -2.466c-1.776 -1.024 -3.288 -.759 -4.314 -2.534c-1.025 -1.775 -.04 -2.95 -.04 -5s-.985 -3.225 .04 -5c1.026 -1.775 2.537 -1.51 4.314 -2.534c1.776 -1.026 2.302 -2.466 4.353 -2.466s2.577 1.441 4.353 2.466c1.776 1.024 3.288 .759 4.313 2.534c1.026 1.775 .04 2.95 .04 5z" />
                </svg>
            </span>
            <span className="logo__text">
                <span className="logo__name">Mooz</span>{" "}
                {onHelp && <span className="logo__suffix">Support</span>}{" "}
                <span className="logo__beta">Beta</span>
            </span>
        </Link>
    );
}
